export default {
  // 页面标题
  title: '活动详情',
  // KPI 卡片
  participantCount: '活动参与人数',
  winnerCount: '中奖人数',
  loserCount: '未中奖人数',
  yesterday: '昨日:',
  // Tab 标签
  tabBasic: '基本信息',
  tabScope: '活动范围',
  tabPrize: '活动奖项',
  tabStrategy: '活动策略',
  // 基本信息
  activityStatus: '活动状态',
  activityName: '活动名称',
  activityId: '活动ID',
  activityTemplate: '活动模板',
  activityTime: '活动时间期间',
  activityRemark: '活动备注',
  activityRule: '活动规则',
  createTime: '创建时间',
  // 活动范围
  colRangeType: '范围类型',
  colCodeRange: '码段范围',
  colCodeCount: '码数量',
  emptyScope: '暂无活动范围数据',
  // 活动奖项
  colPrizeName: '奖项名称',
  colPrizePercent: '中奖概率',
  colPrizeContent: '奖项内容',
  colPrizePloy: '关联策略',
  emptyPrize: '暂无活动奖项数据',
  // 活动策略
  colStrategyName: '策略名称',
  colStrategyRules: '策略规则',
  colStrategyStatus: '策略状态',
  emptyStrategy: '暂无活动策略数据',
};
